import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { jwtDecode } from 'jwt-decode';
//import { ConfigData, token_openIdData } from '../interfaces/config.interface';




@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private userIdSubject = new BehaviorSubject<string  | null>(null);
  userId$: Observable<string  | null> = this.userIdSubject.asObservable();

  constructor(private route: ActivatedRoute) {
    this.initializeConfig();
  }

  private initializeConfig() {
    this.route.queryParams.subscribe(params => {
      const tokenId = params['token'];
      if (tokenId) {
        // Si encontramos un token en la URL, lo decodificamos
        try {
          const decodedToken: any = jwtDecode(tokenId); // Aquí decodificamos el JWT
          const userId = decodedToken.userId; // Extraemos el userId del payload

          if (userId) {
            this.userIdSubject.next(userId);
          } else {
            console.error('No se encontró la configuración para OpenId:', userId);
            this.userIdSubject.next(null);
          }
        } catch (error) {
          console.error('Error al decodificar el token:', error);
        }
      } else {
        // Si no hay token en la URL, seguimos con la carga normal
        console.warn('No hay token en la URL');
      }
    });
  }
}


